export default __webpack_public_path__ + "static/electrics-cc0358f57a7782fea9cdb038edfc1f7c.png";